import React, { FC } from "react";
import classNames from "classnames";
import { Fa } from "composants/Icon";
import { IconName } from "@fortawesome/pro-solid-svg-icons";

export type ToolbarButtonProps = {
  className?: string;
  icon: IconName;
  isActive: boolean;
  disabled?: boolean;
  title?: string;
  onClick(): void;
};

const ToolbarButton: FC<ToolbarButtonProps> = props => {
  return (
    <button
      className={classNames("button mr-8", props.isActive && "is-link", props.className)}
      title={props.title}
      disabled={props.disabled}
      onMouseDown={e => {
        e.preventDefault(); // empêche l'éditeur de perdre le focus
        if (!props.disabled) {
          props.onClick();
        }
      }}
    >
      <span className={classNames("icon", !props.isActive && "has-text-link")}>
        <Fa icon={["fad", props.icon]} />
      </span>
    </button>
  );
};

export default ToolbarButton;
